import {FiltersGamesMobilePopupDefaultBox} from "./filters-games-mobile-popup.default.box";

export const FiltersGamesMobilePopupBox = FiltersGamesMobilePopupDefaultBox;